'use client';

import { ButtonRow, Button, ButtonProps } from '@instamenu/ui-system-next';
import { formatCurrency } from '@instamenu/formatters';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/navigation';
import { useCheckoutContext } from '@instamenu/context-checkout';
import { useSearchParams } from 'next/navigation';

export const ActionBar = observer((props: { buttonProps?: ButtonProps }) => {
  const checkout = useCheckoutContext();
  const router = useRouter();

  if (!checkout) return null;
  const { order } = checkout;

  const hasAvailableItems = order.orderItems.some((orderItem) => !orderItem.isUnavailable);

  const checkoutDisabled =
    !order.id ||
    !(checkout.isAcceptingInstantOrders || checkout.isAcceptingScheduledOrders) ||
    order.orderItems.length < 1 ||
    order.netOrderItemsTotal < order.restaurant.currentMenu.minGrossSubtotal ||
    !hasAvailableItems;

  const searchParams = useSearchParams();
  const checkoutURL = new URL(window.location.origin + `/orders/${order.id}`);
  searchParams.forEach((v, k) => checkoutURL.searchParams.append(k, v));

  const handleCheckout = () => {
    checkout.removeUnavailableItems();
    if (!order.orderItems.length) return;
    router.push(checkoutURL.href);
  };

  return (
    <ButtonRow>
      <Button
        disabled={checkoutDisabled}
        loading={order.loading}
        onClick={handleCheckout}
        data-id="go-to-checkout"
        {...props.buttonProps}
      >
        {checkout.isAcceptingInstantOrders || checkout.isAcceptingScheduledOrders
          ? `Checkout ${formatCurrency(order.netOrderItemsTotal)} (${order.numItems})`
          : 'Not accepting online orders'}
      </Button>
    </ButtonRow>
  );
});
